
import React, { Component } from 'react';
import PracticeListRoot from './PracticeListRoot'
import { Popconfirm, message } from 'antd';
import DisplayNumber from './containers/DisplayNumber'
import { Link, Route, Switch, BrowserRouter as Router } from "react-router-dom"
import { Input, Image, Layout, Menu, Breadcrumb, Col, Row, Divider } from 'antd';
import { Button,  Progress, Table, Tag, Space } from 'antd';
import { Typography, PageHeader } from 'antd';
import axios from 'axios'
const { TextArea } = Input;
const { Title } = Typography;
const { Header, Content, Footer } = Layout;








const { Column, ColumnGroup } = Table;

export default class ReviewPage extends Component{
  state = {
    data: {
      record_image_urls:[],
      record_report_urls:[]
    },
    username: '',
    deny_comment: ''
  }
  curriculum_step_dict={
    'prevet':'예과과정',
    'preclinical': '본과 비임상과정',
    'clinical':'본과 임상과정',
  }
  componentDidMount() {
    let record_id = this.props.match.params.record_id
    let req_data = {
      record_id: record_id
    }
    let data = []
    axios('/record/detail', {
      method: "POST",
      headers: {
          "Content-Type": "application/json; charset=utf-8"
      },
      data: req_data
    }).then( res => {
      let record = res.data.record
      let data = {
        ...record,
        record_report_urls: res.data.record_report_urls,
        record_image_urls: res.data.record_image_urls,
        key: 0,
        etc: record.etc.replace(' ', ', '),
      }
      this.setState({
        ...this.state,
        username: res.data.name,
        data: data,
      })

    });
    
  }

  denyChange = e => {
    this.setState({
      ...this.state,
      deny_comment: e.target.value
    })
  }

  reviewRecord(record_id, is_accepted, deny_comment='') {
    
    let req_data = {
      record_id: record_id,
      is_accepted: is_accepted,
      deny_comment: deny_comment
    }
    axios('/record/review', {
      method: "POST",
      headers: {
          "Content-Type": "application/json; charset=utf-8"
      },
      data: req_data
    }).then( res => {
      if (res.data.is_accepted) {
        message.info('승인되었습니다');
      } else {
        message.info('반려되었습니다');
      }
      window.history.back()
    });
  }
  render () {
    let data= [
      {
        key: '1',
        title: '실습 분류1',
        content: this.state.data.primary_class,

      },
      {
        key: '2',
        title: '실습 분류2',
        content: this.state.data.secondary_class,

      },
      {
        key: '3',
        title: '커리큘럼 분류',
        content: this.curriculum_step_dict[this.state.data.curriculum_step],

      },
      {
        key: '4',
        title: '실습 날짜',
        content: `${new Date(this.state.data.start_at).toLocaleDateString('ko-KR', {year:'numeric', month:'long', day:'numeric', hour:'numeric'})} - ${new Date(this.state.data.end_at).toLocaleDateString('ko-KR', {year:'numeric', month:'long', day:'numeric', hour:'numeric'})}`,

      },
      {
        key: '5',
        title: '실습 기관',
        content: this.state.data.institute,
      },
      {
        key: '6',
        title: '실습 내용',
        content: this.state.data.practice,
      },
      {
        key: '7',
        title: 'Domains of Competency',
        content: (this.state.data.competency? this.state.data.competency.split(' ').map((x) => {return <Tag>{x}</Tag>}) : '')
      },
      {
        key: '8',
        title: '비고',
        content: this.state.data.etc,
      },
      {
        key: '9',
        title: '실습 담당자',
        content: this.state.data.professor,
      },
      {
        key: '10',
        title: '실습 담당자 연락처',
        content: this.state.data.professor_phone,
      },
      {
        key: '11',
        title: '실습 성과',
        content: <pre style={{whiteSpace:'pre-line'}}>{this.state.data.report}</pre>,
      },
      {
        key: '12',
        title: '실습 보고서',
        content: (
          <Image.PreviewGroup>
            {
              this.state.data.record_report_urls.map((url) => {
                return (<Link onClick={() => {window.open('/'  + url) }}> <Image width={100} src={'/file_png.png'} disabled/></Link>)
              })

            }
          </Image.PreviewGroup>
        )
      },
      {
        key: '13',
        title: '실습 사진',
        content: (
          <Image.PreviewGroup>
            {
              this.state.data.record_image_urls.map((url) => {
                return (<Image width={200} src={'/' + url} />)
              })

            }
          </Image.PreviewGroup>
        )
      },
      {
        key: '14',
        title: '승인 상태',
        content: <Tag>{this.state.data.state}</Tag>
      },
    ];

      return (
      
      
      <>
      <PageHeader
        className="site-page-header"
        onBack={() => window.history.back()}
        title={this.state.data.institute}
        subTitle="상세 실습 내역"
        extra={[

          this.state.data.state == '승인대기' ? ([<Popconfirm
              placement="bottomRight"
              title={<TextArea rows={3} placeholder='반려사유 입력' onChange={this.denyChange} />}
              onConfirm={() => this.reviewRecord(this.props.match.params.record_id, false, this.state.deny_comment)}
              okText="반려"
              cancelText="취소"
            >
              <Button key="2" type='dashed' danger>반려</Button>
            </Popconfirm>,
            <Popconfirm
              placement="bottomRight"
              title='해당 실습을 승인하시겠습니까?'
              onConfirm={() => this.reviewRecord(this.props.match.params.record_id, true)}
              okText="승인"
              cancelText="취소"
            >
              <Button key="1" type="primary">
                승인
              </Button>
            </Popconfirm>]):'',

          this.state.data.state == '반려' ? (<Popconfirm
              placement="bottomRight"
              title='해당 실습을 승인하시겠습니까?'
              onConfirm={() => this.reviewRecord(this.props.match.params.record_id, true)}
              okText="승인"
              cancelText="취소"
            >
              <Button key="1" type="primary">
                승인
              </Button>
            </Popconfirm>):'',

          this.state.data.state == '승인완료' ? (<Popconfirm
              placement="bottomRight"
              title={<TextArea rows={3} placeholder='반려사유 입력' onChange={this.denyChange} />}
              onConfirm={() => this.reviewRecord(this.props.match.params.record_id, false, this.state.deny_comment)}
              okText="반려"
              cancelText="취소"
            >
              <Button key="2" type='dashed' danger>반려</Button>
            </Popconfirm>):'',

        ]}



      />
      <Table dataSource={data} style={{margin:'0 50px' ,marginLeft:'150px', marginRight:'150px'
      }}
      pagination={false}
      >
        {/* <ColumnGroup title="Name">
          <Column title="First Name" dataIndex="firstName" key="firstName" />
          <Column title="Last Name" dataIndex="lastName" key="lastName" />
        </ColumnGroup> */}
        <Column columnWidth='80px' title="" dataIndex="title" key="title" />
        <Column title="" dataIndex="content" 
        style={{
          whiteSpace: 'pre-line'
        }} 
        key="content" />
        {/* <Column
          title=""
          dataIndex="tags"
          key="tags"
          render={tags => (
            <>
              {tags.map(tag => (
                <Tag color="blue" key={tag}>
                  {tag}
                </Tag>
              ))}
            </>
          )}
        />
        <Column
          title=""
          key="action"
          render={(text, record) => (
            <Space size="middle">
              <a>Invite {record.lastName}</a>
              <a>Delete</a>
            </Space>
          )}
        /> */}
      </Table>
      <Divider >


      </Divider>
      </>
      ) 
  };
};